import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import bodyStyles from "./bodyStyles";

const {
	breakPoints: { screenQuery },
} = theme;

const Body5 = styled.p(
	bodyStyles,
	`
  font-size: 16px;
  line-height: 24px;
  ${screenQuery.large}{
    font-size: 14px;
    line-height: 16px;
  }
  ${screenQuery.small}{
    font-size: 12px;
    line-height: 16px;
  }
  p {
    font-size: 16px;
    line-height: 24px;

    ${screenQuery.large}{
      font-size: 14px;
      line-height: 16px;
    }
    ${screenQuery.small}{
      font-size: 12px;
      line-height: 16px;
    }
  }
`
);

export default ({ children, ...props }) => <Body5 {...props}>{children}</Body5>;
